import CarCardPreview from "components/CarCard/CarCardPreview";
import React, { FC, useEffect } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
// import ButtonSecondary from "shared/Button/ButtonSecondary";
import CommonLayout from "./CommonLayout";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { useHistory } from "react-router";

export interface PageAddListing10Props {}

const PageAddListing10: FC<PageAddListing10Props> = () => {
  const history = useHistory();

  const { product } = useSelector((state: RootState) => state.productUpload);

  useEffect(() => {
    if (!product.name) {
      history.push("/add-listing-1");
    }
  }, []);

  const handleSubmit = (e: any) => {
    // dispatch(addListing());
    e.preventDefault();
  };

  return (
    <CommonLayout
      nextBtnText="Daftarkan Barangmu"
      index="6"
      backtHref="/add-listing-8"
      nextHref="/"
    >
      <>
        <div>
          <h2 className="text-2xl font-semibold">Selamat 🎉</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Selamat, barangmu sudah terdaftar. Tim Rentrips akan melakukan
            pengecekan sebelum menampilkan barangmu
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* FORM */}
        <form onSubmit={handleSubmit}>
          <h3 className="text-lg font-semibold">
            Berikut adalah tampilan barangmu
          </h3>
          <div className="max-w-xs">
            <CarCardPreview className="mt-8" data={product} kabupaten={""} />
          </div>
          <div className="flex items-center space-x-5 mt-8">
            {/* <ButtonSecondary>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                />
              </svg>
              <span className="ml-3">Preview</span>
            </ButtonSecondary> */}
            <ButtonPrimary type="submit" href="/vendor-listing">
              Ke Profil
            </ButtonPrimary>
          </div>
        </form>
        {/*  */}
      </>
    </CommonLayout>
  );
};

export default PageAddListing10;
